module.exports = __webpack_public_path__ + "static/img/138_TO8_1836_og.92d1eb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/138_TO8_1836_og.jpg
// module id = YJqZ
// module chunks = 0